import React from 'react';
import { DateTime } from 'luxon';
import {
  formatAbstractNumberToString,
  formatLongPrice,
  formatNumber,
  getPureNumber,
  getValueBgClass,
  transformPercentageValue,
} from '@benzinga/calendars';
import { Ticker, TickerLink } from '@benzinga/ticker-ui';
import { Earnings } from '@benzinga/calendar-manager';

export const EarningsColumnsDef = [
  {
    cellRenderer: ({ data }: { data: Earnings }) => {
      return (
        <Ticker
          slug="earnings"
          symbol={data.ticker}
          targetElement={
            <TickerLink slug="earnings" symbol={data.ticker}>
              {data.ticker}
            </TickerLink>
          }
        />
      );
    },
    field: 'ticker',
    headerName: 'Ticker',
  },
  {
    cellClass: 'semibold',
    colSpan: 3,
    field: 'name',
    headerName: 'Company',
  },
  {
    field: 'time',
    headerName: 'Time',
    valueFormatter: ({ data }) => {
      const result = DateTime.fromISO(data.time).toLocaleString(DateTime.TIME_SIMPLE);
      return result;
    },
  },
  {
    cellClass: 'semibold',
    field: 'eps',
    headerName: 'EPS',
    valueFormatter: ({ data }: { data: Earnings }) => formatAbstractNumberToString(data.eps, data.eps_type),
  },
  {
    field: 'eps_est',
    headerName: 'EPS Est',
    valueFormatter: ({ data }: { data: Earnings }) => formatAbstractNumberToString(data.eps_est, data.eps_type),
  },
  {
    cellClass: ({ data }: { data: Earnings }) => getValueBgClass(data.eps_surprise),
    field: 'eps_surprise',
    headerName: 'EPS Surprise',
    valueFormatter: ({ data }: { data: Earnings }) => formatAbstractNumberToString(data.eps_surprise, data.eps_type),
  },
  {
    field: 'revenue',
    headerName: 'Rev',
    valueFormatter: ({ data }: { data: Earnings }) => formatAbstractNumberToString(data.revenue, data.revenue_type),
  },
  {
    field: 'revenue_est',
    headerName: 'Rev Est',
    valueFormatter: ({ data }: { data: Earnings }) => {
      const value = getPureNumber(data.revenue_est);
      const formattedNumber = formatLongPrice(value, '');
      return formattedNumber;
    },
  },
  {
    cellClass: ({ data }: { data: Earnings }) => getValueBgClass(data.revenue_surprise),
    field: 'revenue_surprise',
    headerName: 'Rev Surprise',
    valueFormatter: ({ data }: { data: Earnings }) => {
      const value = transformPercentageValue(data.revenue_surprise_percent);
      const formattedNumber = value ? formatNumber(value, '%') : '';
      return formattedNumber;
    },
  },
];

export default EarningsColumnsDef;
